<template>
  <div
    v-shortcut.meta="{ key: shortcutKey }"
    v-b-tooltip.hover.html="{
      delay: { show: 600, hide: 0 },
      title: tooltip,
      placement: tooltipPlacement
    }"
    class="caret-button"
    @click.prevent="click"
    @keydown.enter.prevent="click"
    @shortcut="click"
  >
    <elIcon
      :name="icon"
      size="lg"
    />
    <span
      v-if="direction === 'up'"
      :class="'caret-' + (active ? 'down' : 'up')"
    />
    <span
      v-if="direction === 'left'"
      :class="'caret-' + (active ? 'right' : 'left')"
    />
  </div>
</template>

<script>
import { VBTooltip } from '@ui/components'
import elIcon from './elIcon.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip
  },
  components: {
    elIcon
  },
  props: {
    shortcutKey: Number,
    active: Boolean,
    direction: {
      type: String,
      default: 'up'
    },
    icon: String,
    tooltip: String,
    tooltipPlacement: {
      type: String,
      default: 'top'
    }
  },
  emits: ['click'],
  methods: {
    click() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
@import '~@ui/styles/src/scss/utils/lib';

.caret-button {
  display: inline-block;
  padding: 0 6px;
  color: $secondaryColor;
  font-size: _rem(15);
  line-height: 2;
  background-color: rgba($secondaryColor, 0.1);
  border-radius: 3px;
  cursor: pointer;
  user-select: none;

  .open > &,
  &:hover,
  &:focus {
    color: scale-color($secondaryColor, $lightness: -10%);
    background-color: rgba($secondaryColor, 0.3);
  }
}

</style>
